import { mergeSettings } from 'helpers/settingsHelpers';
import { defaultProjectListSettings, defaultWorksheetListSettings, defaultProjectMassListSettings, defaultWorksheetMassListSettings } from 'constants/defaultSettings';

export const worksheetSettingsMapper = (data) => {
    return mergeSettings(defaultWorksheetListSettings, data);
}

export const worksheetMassSettingsMapper = (data) => {
    return mergeSettings(defaultWorksheetMassListSettings, data);
}

export const projectSettingsMapper = (data) => {
    return mergeSettings(defaultProjectListSettings, data);
}

export const projectMassSettingsMapper = (data) => {
    return mergeSettings(defaultProjectMassListSettings, data);
}
